<template>
  <div class="results--loading" v-if="loadingEvents">
    Loading...
  </div>
  <div class="events-carousel results--loaded" :data-carousel="eventList.length > 3" v-else>
    <span v-if="eventList.length === 0">There are no results for your search</span>
    <EventDetails
      v-else
      v-for="event in eventList"
      :key="event.id"
      :event="event"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventDetails from './EventDetails.vue'

export default {
  name: 'EventResults',
  components: { EventDetails },
  computed: {
    ...mapState(['loadingEvents']),
    eventList () {
      return this.$store.getters['eventsForLocation']
    }
  }
}
</script>
